import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initAmplitude, trackAmpAppOpened } from '@/services/amplitudeService';
import { startAppUpdateWatch } from '@/services/appUpdateService';
import { captureAdAttribution } from '@/services/metaPixel';
import { installTranslatorDomGuard } from '@/utils/translatorDomGuard';

// Keep fbclid / gclid / utm_* from the arrival URL before initAmplitude() scrubs utm_* (ad attribution).
captureAdAttribution();
// Initialize Amplitude before rendering so anonymous arrivals are captured
// from the first paint. GA is loaded via index.html and untouched.
initAmplitude();
// Owner funnel: 'App Opened' once per tab session (V1 and V2 — this runs
// before the version fork). The webapp-arrival + DAU baseline event.
trackAmpAppOpened();
// Reload an idle tab once the updated service worker has taken control, so a
// long-open tab stops running the previous build. No-op if anything fails.
try {
  startAppUpdateWatch();
} catch {
  // Ignored — never block the app from rendering.
}

installTranslatorDomGuard();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

